module.exports = __webpack_public_path__ + "03_short_gray.fc3de5f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_short_gray.png
// module id = 9ypk
// module chunks = 0